export { default as NavBar } from "./Navbar";
export { default as Home } from "./pages/Home";
// export { default as FindTutor } from "./pages/FindTutor";
export { default as Faq } from "./pages/Faq";
export { default as OurTutors } from "./pages/OurTutors";
export { default as WorkWithUs } from "./pages/WorkWithUs";
export { default as Contact } from "./pages/Contact";
export { default as Footer } from "./Footer";

// Components
export { default as Hero } from "./Hero";
export { default as About } from "./About";
export { default as Julian } from "./Julian";
export { default as WhyUs } from "./WhyUs";

//Leader image
export { default as JulianImage } from "./assets/tutors/Julian.jpeg";
export { default as Berry } from "./assets/tutors/Berry.jpeg";
export { default as Claire } from "./assets/tutors/Claire.jpeg";
export { default as Evelyn } from "./assets/tutors/Evelyn.jpeg";

// Tutor image
export { default as Ahelee } from "./assets/tutors/Ahelee.jpeg";
export { default as Alexander } from "./assets/tutors/Alexander.jpeg";
export { default as Amy } from "./assets/tutors/Amy.jpeg";
export { default as An } from "./assets/tutors/An.jpeg";
export { default as Andy } from "./assets/tutors/Andy.jpeg";
export { default as Ashani } from "./assets/tutors/Ashani.jpeg";
export { default as Carol } from "./assets/tutors/Carol.jpeg";
export { default as Cindy } from "./assets/tutors/Cindy.jpeg";
export { default as Danielle } from "./assets/tutors/Danielle.jpeg";
export { default as Diya } from "./assets/tutors/Diya.jpeg";
export { default as Emily } from "./assets/tutors/Emily.jpeg";
export { default as Jade } from "./assets/tutors/Jade.jpeg";
export { default as Jesslyn } from "./assets/tutors/Jesslyn.jpeg";
export { default as Jiya } from "./assets/tutors/Jiya.jpeg";
export { default as Lilian } from "./assets/tutors/Lilian.jpeg";
export { default as Magdalene } from "./assets/tutors/Magdalene.jpeg";
export { default as Megan } from "./assets/tutors/Megan.jpeg";
export { default as Nhi } from "./assets/tutors/Nhi.jpeg";
export { default as Pakhi } from "./assets/tutors/Pakhi.jpeg";
export { default as Rachael } from "./assets/tutors/Rachael.jpeg";
export { default as Ryan } from "./assets/tutors/Ryan.jpeg";
export { default as Sabina } from "./assets/tutors/Sabina.jpeg";
export { default as Samantha } from "./assets/tutors/Samantha.jpeg";
export { default as Sammi } from "./assets/tutors/Sammi.jpeg";
export { default as Stacey } from "./assets/tutors/Stacey.jpeg";
export { default as Sylvia } from "./assets/tutors/Sylvia.jpeg";
export { default as Tammy } from "./assets/tutors/Tammy.jpeg";
export { default as Tristina } from "./assets/tutors/Tristina.jpeg";

// Policies
export { default as childSafeWellbeing } from "../policies/Child Safe and Wellbeing Policy Issue 1.pdf";
export { default as childSafeConduct } from "../policies/Child Safe Code of Conduct Issue 1.pdf";
export { default as covidSafePlan } from "../policies/COVIDSafe Plan for In Person Learning Issue 9.pdf";
export { default as privacyPolicy } from "../policies/Privacy Policy Issue 1.pdf";
export { default as cancellationPolicy } from "../policies/Private Tutoring Lesson Cancellation Policy Issue 4.pdf";
export { default as refundPolicy } from "../policies/Refund Policy Issue 1.pdf";

// Motion effects
export const fadeUp = {
  hidden: {
    opacity: 0,
    y: 50,
  },
  visible: {
    opacity: 1,
    y: 0,
  },
};

export const fadeDown = {
  hidden: { opacity: 0, y: -50 },
  visible: {
    opacity: 1,
    y: 0,
  },
};

export const fadeLeftToRight = {
  hidden: { opacity: 0, x: -50 },
  visible: {
    opacity: 1,
    x: 0,
  },
};

export const fadeRightToLeft = {
  hidden: { opacity: 0, x: 50 },
  visible: {
    opacity: 1,
    x: 0,
  },
};

export const drawSolidSvg = {
  hidden: { pathLength: 0 },
  visible: {
    pathLength: 1,
  },
};

export const drawDashedSvg = {
  hidden: { pathLength: 0 },
  visible: {
    pathLength: 0.2,
    pathSpacing: 0.4,
  },
};
